const images = {
    ciLogo: require('./CI landscape logo gr yellow 18x6.png'),
};

export default images;



// WEBPACK FOOTER //
// ./src/assets/images/images.js